import { Breadcrumb, Flex, Space, Tag, Typography } from 'antd'

import { useStyles } from './styles'
import type { PageHeaderProps } from './types'

const { Title, Text } = Typography

export const PageHeader = ({
  title,
  subtitle,
  breadcrumb,
  actions,
  count
}: PageHeaderProps) => {
  const { styles } = useStyles()

  if (!title && !subtitle && !breadcrumb && !actions) {
    return null
  }

  return (
    <div className={styles.pageHeader}>
      <Flex align="flex-end" justify="space-between" gap="middle" wrap>
        <Flex vertical gap={4}>
          {breadcrumb && breadcrumb.length > 0 ? (
            <Breadcrumb items={breadcrumb} className={styles.pageBreadcrumb} />
          ) : null}
          {title ? (
            <Flex align="center" gap={10}>
              <Title level={3} className={styles.pageTitle}>
                {title}
              </Title>
              {count != null ? (
                <Tag style={{ marginInlineEnd: 0 }}>
                  {count.toLocaleString()}
                </Tag>
              ) : null}
            </Flex>
          ) : null}
          {subtitle ? (
            <Text type="secondary" className={styles.pageSubtitle}>
              {subtitle}
            </Text>
          ) : null}
        </Flex>
        {actions ? <Space size="small">{actions}</Space> : null}
      </Flex>
    </div>
  )
}
